export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-02.9861f82c.png";